import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TextMessage} from '../model/email/TextMessage';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';

@JsonConverter
export class TextMessageConverter implements JsonCustomConvert<Array<TextMessage>> {
    deserialize(json: any): Array<TextMessage> {


        const textMsgArr:Array<TextMessage> =  [];
        // const temp:TSMap<string,EmailBanner>= new TSMap();

        for (const item of json) {
            textMsgArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,TextMessage));
        }

        return textMsgArr;
    }

    serialize(data: Array<TextMessage>): any {
        return JSON.stringify(data);
    }
}
